// @flow
import { getThemeStringProp } from "./themeProps";

import type { UtilThemeProps } from "../types";

const DEFAULT_CORNER_PROPERTY = "border-radius";

/*
 * Border radius based on the theme setting for rounded corners
 * When ROUNDED_CORNERS is not true in the theme, no rounded corners are returned
 */
/**
 */
const roundedCorners =
  (
    property: string = DEFAULT_CORNER_PROPERTY,
    path: string = "BORDER_RADIUS",
    defaultValue: string = "0.25rem",
  ): ((UtilThemeProps) => string) =>
  ({ theme = { settings: {} } }: UtilThemeProps) => {
    if (theme.ROUNDED_CORNERS) {
      const propertyName =
        property && property !== DEFAULT_CORNER_PROPERTY
          ? `border-${property}-radius`
          : DEFAULT_CORNER_PROPERTY;

      return `${propertyName}: ${getThemeStringProp(
        theme,
        path,
        defaultValue,
      )}`;
    }

    return "";
  };

export { roundedCorners };
